import { normalizeProduct, toNumber } from "./dataLayer";

/**
 * Map cart API / UI product rows to GA4 items.
 */
export function mapCartProductsToItems(cartProducts) {
  if (!Array.isArray(cartProducts)) return [];
  return cartProducts
    .map((row) => {
      if (!row) return null;
      if (row.item_id) return row;
      const qty = toNumber(row.qty ?? row.quantity ?? row.count ?? 1) || 1;
      const price = toNumber(
        row.price ??
          row.promoPrice ??
          row.OnlineSelingPrice ??
          row.sellingPrice ??
          row.selling_price ??
          row.promo_price ??
          row?.product?.promo_price ??
          row?.skus?.[0]?.selling_price
      );
      const productLike = {
        id: row.seller_product_id || row.product_id || row.id,
        li_product_id: row.li_product_id,
        product_name:
          row.productName ||
          row.product_name ||
          row.name ||
          row?.product?.product_name ||
          row.title,
        brand: row.brandName || row.brand || row?.product?.brand,
        categories: row.categories || row?.product?.categories,
        price,
        skus: row.skus || row?.product?.skus,
        product: row.product,
      };
      return normalizeProduct(productLike, qty);
    })
    .filter(Boolean);
}

export function paymentTypeLabel(activePaymentId) {
  if (activePaymentId == null) return undefined;
  if (typeof activePaymentId === "string") return activePaymentId;
  const map = {
    1: "cash",
    15: "idram",
    16: "tellcell",
    17: "arca",
    18: "credit",
    19: "ineco",
    20: "bank_transfer",
    21: "myameria",
  };
  return map[activePaymentId] || String(activePaymentId);
}
